/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {getUserByToken, login} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'
import Swal from 'sweetalert2';

const loginSchema = Yup.object().shape({
  /*
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
    */
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const [showRegAs, setShowRegAs] = useState(false)
  const {saveAuth, setCurrentUser,currentUser} = useAuth()
  const Swal = require('sweetalert2')

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await login(values.email, values.password)
        saveAuth(auth)
        const {data: user} = await getUserByToken(auth.usrToken)
        if(user){
          //console.log("gandhi login : " + user.usrRoleList?.moduleName[0]);
          //setCurrentUser(user)
          //setLoading(false) 
          if(user.usrIsActive){
            Swal.fire({
              title: "Success!",
              html: 'Login successfully, welcome <strong>' + user.usrFirstname + " " + user.usrLastname + "<strong>",
              icon: "success",
              timer: 2000,
              showConfirmButton: false
            }).then(() => {
              localStorage.setItem("xuser",values.email)
              localStorage.setItem("xpwd",values.password)
              if(user?.usrIsAdmin){
                if(user.usrIsAdminCenter || user?.usrRoleName.toLowerCase().includes("kidstart")){
                  window.location.href = "/pages/MyProfileAdminDashboard/SetupProgrammes";
                }else{
                  window.location.href = "/pages/MyProfileAdmin/Overview";
                }
              }else{
                window.location.href = "/pages/MyProfile/Overview";
              }
            })  
          }else{
            saveAuth(undefined)
            setLoading(false)
            Swal.fire({
              title: 'Error!',
              text: 'Your account is disable, please contact administrator!',
              icon: 'error',
              confirmButtonText: 'Okay'
            })            
          }
        }else{
          setLoading(false)
          Swal.fire({
            title: 'Error!',
            text: 'The login details are incorrect!',
            icon: 'error',
            confirmButtonText: 'Okay'
          })
        }
        //console.log(currentUser)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        Swal.fire({
          title: 'Error!',
          text: 'The login details are incorrect!',
          icon: 'error',
          confirmButtonText: 'Okay'
        })       
        setSubmitting(false)
        setLoading(false)
      }
    },
  })
  const AskFirst=()=>{
    //setShowRegAs(true)
    Swal.fire({
      title: "Please select register as?",
      //showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Teacher",
      //denyButtonText: "Volunteer",
      allowOutsideClick: false,
    }).then((result:any) => {
      if (result.isConfirmed) {
        window.location.href = "/auth/regas/teacher";
      }
      /* 
      else if (result.isDenied) {
        window.location.href = "/auth/regas/volunteer";
      }
        */
    });
  }
  return (
    <>
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
        {/* begin::Heading */}
        <div className='text-center mb-11'>
          <h1 className='text-dark fw-bolder mb-3'>Sign In</h1>
          <div className='text-gray-500 fw-semibold fs-6'>Please login using your account</div>
        </div>
        {/* begin::Heading */}

        {formik.status && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status}</div>
          </div>
        ) /* : (
          <><div className='mb-10 bg-light-info p-8 rounded'>
            <div className='text-info'>
              Administrator : <strong>admin@demo.com</strong> & password <strong>demo</strong><br />
              <hr />
              Volunteer : <strong>volunteer@demo.com</strong> & password <strong>demo</strong>
            </div>
          </div></>
        ) */}

        {/* begin::Form group */}
        <div className='fv-row mb-8'>
          <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
          <input
            placeholder='Email'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control bg-transparent',
              { 'is-invalid': formik.touched.email && formik.errors.email },
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
            type='email'
            name='email'
            autoComplete='off' />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='fv-row mb-3'>
          <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
          <input
            type='password'
            autoComplete='off'
            {...formik.getFieldProps('password')}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.password && formik.errors.password,
              },
              {
                'is-valid': formik.touched.password && !formik.errors.password,
              }
            )} />
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.password}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Wrapper */}
        <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
          <div />

          {/* begin::Link */}
          <Link to='/auth/forgot-password' className='link-primary'>
            Forgot Password ?
          </Link>
          {/* end::Link */}
        </div>
        {/* end::Wrapper */}

        {/* begin::Action */}
        <div className='d-grid mb-10'>
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-primary'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label'>Login</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Action */}

        <div className='text-gray-500 text-center fw-semibold fs-6 mb-10'>
          Not a Member yet?{' '}
          <a href="javascript:;" onClick={AskFirst} className='link-primary'>
            Sign up
          </a>
        </div>
        {showRegAs && 
        <div className='row'>
            <hr className='text-gray-500'/>
            <div className="d-flex justify-content-center mb-5"><h4 className='text-gray-500'>Register As</h4></div>
            <div className='col-md-3'>
              <a href="/auth/regas/parent" className='btn btn-primary'>Parent</a>
            </div>
            <div className='col-md-3'>
              <a href="/auth/regas/volunteer" className='btn btn-primary'>Volunteer</a>
            </div>
            <div className='col-md-3'>
              <a href="/auth/retrieveregdata" className='btn btn-primary'>Participant</a>
            </div>
            <div className='col-md-3'>
              <a href="javascript:;" onClick={() => {setShowRegAs(false)}} className='btn btn-danger'>Cancel</a>
            </div>
        </div>
      }
      </form></>
  )
}
